<template>
  <div>
    <h2>{{ $t('Access denied') }}</h2>
    <p>{{ $t('You are unauthorized to access this page.') }}</p>
  </div>
</template>

<script>
export default {
  name: 'unauthorized'
};
</script>

<style scoped>

</style>
